import createComponent, {
  ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const NavContainer = createComponent('nav', {
  className: `
    flex md:flex-col
    px-2xl py-md md:p-md
    overflow-auto
    md:rounded-2xl
    bg-canvas-default
    w-full md:w-[208px]
    self-start
    sticky top-0 md:mt-5xl md:top-5xl
    z-10 md:z-auto
    shadow-[0_4px_6px_-1px_rgb(0_0_0/0.1)] md:shadow-DEFAULT
  `
});

export const NavItemWrapper = createComponent<
  ElementWithProps & { isVisible: boolean }
>('div', ({ isVisible }) => ({
  className: cx(
    'shrink-0 overflow-hidden transition-all duration-300 ease-in-out',
    isVisible
      ? 'max-h-44 max-w-full opacity-100 mr-sm md:mr-0 md:mb-sm'
      : 'max-h-0 max-w-0 opacity-0'
  )
}));
